import { useState } from 'react';

import { Utils } from '@mvrb-frontend/shared-ui';

import { ResponseException } from '../models';
import { AxiosPrivate } from '../utils/axios';
import { PaginationQuery } from '../interfaces/paginationQuery.interface';
import { DistributionListModel, DistributionListItemModel } from '../models';

export const useDistributeReview = () => {
  const [isFetching, setIsFetching] = useState(false);
  const [errors, setErrors] = useState<string[]>([]);
  const [success, setSuccess] = useState(false);

  const submit = async (reviewId: string, payload: any) => {
    try {
      setIsFetching(true);
      await AxiosPrivate.post(`/reviews/${reviewId}/redistribute`, payload);
      setErrors([]);
      setSuccess(true);
    } catch (e) {
      setSuccess(false);
      setErrors(new ResponseException(e).getErrorMessage());
    } finally {
      setIsFetching(false);
    }
  };

  return {
    isFetching,
    success,
    errors,
    submit,
  };
};
